import React, { Component } from 'react'

import HeaderComponent from '../header/HeaderComponent'
import KnowLoanComponent from '../knowloan/KnowloanComponent'
import FindLoanComponent from '../findloan/FindloanComponent'
import CarouselComponent from '../carousel/CarouselComponent'
import LenderComponent from '../lender/LenderComponent'
import FooterComponent from '../footer/FooterComponent'
import TestimonialsComponent from '../testimonials/TestimonialsComponent'

export class MainPage extends Component {
  render() {
    return (
      <>
      <div>
      <HeaderComponent/>
      <CarouselComponent/>
      <LenderComponent/>
      <KnowLoanComponent/>
      <TestimonialsComponent/>
      <FindLoanComponent/>
      <FooterComponent/>
      </div>
      </>
    )
  }
}

export default MainPage;